import React from 'react';

import styled, { keyframes } from 'styled-components';

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const AnimatedItem = styled.div<{ $delay: number }>`
  animation: ${slideUp} 0.6s ease-out forwards;
  animation-delay: ${({ $delay }) => $delay}ms;
  opacity: 0;
  transform: translateY(30px);
  height: 100%;
  display: flex;
  flex-direction: column;
`;

interface StaggerAnimationProps {
  children: React.ReactNode;
  index: number;
  delay?: number;
}

const StaggerAnimation: React.FC<StaggerAnimationProps> = ({
  children,
  index,
  delay = 100
}) => {
  return (
    <AnimatedItem $delay={index * delay}>
      {children}
    </AnimatedItem>
  );
};

export default StaggerAnimation;
